import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {PermissionEnum} from "@app/enums/permissions/PermissionEnum";
import {AccountFeaturesEnum} from "@app/interfaces/config/accountFeaturesEnum";
import {Observable, Subject, timer} from "rxjs";
import {AccountConfig} from "@app/interfaces/config/account.config";
import {ConfigAPIService} from "@app/services/api/config-api.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-trading-hub-sidebar',
  templateUrl: './trading-hub-sidebar.component.html',
  styleUrls: ['./trading-hub-sidebar.component.scss'],
  standalone: false
})
export class TradingHubSidebarComponent implements OnInit, OnDestroy {
  @Input() isShrunk: boolean;

  public tradingHubSideBarItemLabel = $localize`:@@vehicleAuctionSideBarItem:Dražbe vozil`;
  public tradingHubAdminPageSideBarItemLabel = $localize`:@@adminAuctionSideBarItem:Moje dražbe`;
  public tradingHubNotificationCount: number = 0;
  public showAdditionalText: boolean = false;

  protected readonly PermissionEnum = PermissionEnum;
  protected readonly AccountFlagEnum = AccountFeaturesEnum;

  public accountConfig$: Observable<AccountConfig>;
  private destroy$ = new Subject<void>();

  constructor(private configService: ConfigAPIService) {
  }

  ngOnInit() {
    this.accountConfig$ = this.configService.getAccountConfig();

    this.accountConfig$.pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.tradingHubNotificationCount = result.athSummary?.new_daily_auctions_count ?? 0;

        if (this.tradingHubNotificationCount > 0) {
          this.showAdditionalText = true;
          timer(4000).pipe(takeUntil(this.destroy$))
            .subscribe(() => {
              this.showAdditionalText = false;
            });
        }
      });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
